<div *ngIf="config" class="is-modal-backdrop" (click)="onBackdropClick()" (keydown.escape)="onBackdropClick()" role="dialog" aria-modal="true">
  <div class="is-modal" [class]="sizeClass" (click)="$event.stopPropagation()">

    <!-- Icon -->
    <div class="is-modal__icon" [class]="'is-modal__icon--' + config.type">
      <i [class]="'bx ' + icon"></i>
    </div>

    <!-- Title -->
    <h5 class="is-modal__title">{{ config.title }}</h5>

    <!-- Message -->
    <p *ngIf="config.message" class="is-modal__message">{{ config.message }}</p>

    <!-- Form (usa is-dynamic-form) -->
    <div *ngIf="config.type === 'form' && dynamicFormConfig" class="is-modal__form">
      <is-dynamic-form
        #formRef
        [config]="dynamicFormConfig"
        (submitted)="onFormSubmit($event)"
      ></is-dynamic-form>
    </div>

    <!-- Buttons -->
    <div class="is-modal__actions" [class.is-modal__actions--single]="buttons.length === 1">
      <button *ngFor="let btn of buttons" type="button"
        [class]="'btn btn-sm btn-' + (btn.variant || 'primary')"
        (click)="onButtonClick(btn)">
        <i *ngIf="btn.icon" [class]="'bx ' + btn.icon + ' me-1'"></i>{{ btn.label }}
      </button>
    </div>
  </div>
</div>
